class InspectionStatus {
  PENDING = 0;
  DONE = 1;
  CANCELED = 2;

  constructor(inspectionStatus) {
    this.inspectionStatus = inspectionStatus;
  }

  get color() {
    switch (this.inspectionStatus) {
      case this.PENDING:
        return 'default';
      case this.DONE:
        return 'success';
      case this.CANCELED:
        return 'warning';
      default:
        return 'error';
    }
  }

  static create(inspection) {
    return new InspectionStatus(inspection);
  }
}

const InspectionStatusFactory = (inspectionStatus) => new InspectionStatus(inspectionStatus);

export default InspectionStatusFactory;
